import { render, staticRenderFns } from "./UpdateVersionApp.vue?vue&type=template&id=394b0dc0&"
import script from "./UpdateVersionApp.vue?vue&type=script&lang=js&"
export * from "./UpdateVersionApp.vue?vue&type=script&lang=js&"
import style0 from "./UpdateVersionApp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports